import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('DISCARD_APP_NOTIFICATION_OPTIONS', function () {
    var store = getStore();
    store.newMailToast = null;
    store.newMailSound = null;
    store.reminderToast = null;
    store.reminderSound = null;
});
//# sourceMappingURL=discardAppNotificationOptions.js.map